/**
 * Optional Play startup timing (QA). Enable with `?playPerf=1` on /app-beta.
 * Does not change product behavior — console marks only.
 */

export type PlayStartupMark = {
  label: string
  atMs: number
  elapsedMs: number
}

const marks: PlayStartupMark[] = []
let sessionStartMs: number | null = null

function playPerfEnabled(): boolean {
  if (typeof window === 'undefined') return false
  try {
    return new URLSearchParams(window.location.search).get('playPerf') === '1'
  } catch {
    return false
  }
}

export function resetPlayStartupTiming(): void {
  marks.length = 0
  sessionStartMs = null
}

export function markPlayStartup(label: string, detail?: string): void {
  if (typeof performance === 'undefined') return
  const now = performance.now()
  if (sessionStartMs == null) sessionStartMs = now
  const entry: PlayStartupMark = {
    label,
    atMs: now,
    elapsedMs: now - sessionStartMs,
  }
  marks.push(entry)
  if (playPerfEnabled()) {
    const suffix = detail ? ` ${detail}` : ''
    // eslint-disable-next-line no-console
    console.info(
      `[playPerf] ${label.padEnd(36)} +${entry.elapsedMs.toFixed(0)} ms${suffix}`
    )
  }
}

export function markPlayStartupServerTimings(
  timings: Record<string, number> | null | undefined
): void {
  if (!timings) return
  for (const [key, value] of Object.entries(timings)) {
    if (typeof value !== 'number' || !Number.isFinite(value)) continue
    markPlayStartup(`server_${key}`, `${Math.round(value)}ms`)
  }
}

export function getPlayStartupTimingTable(): PlayStartupMark[] {
  return marks.slice()
}
